import {Dropdown} from "primereact/dropdown";
import {Classes, Labeled} from "./Basics";

type Properties = Classes & Labeled & {
    val: any
    options: Array<string>
    onChange: (val: string) => void
}

function PredefinedTextSetProperty(props: Properties) {
    function handleOnChange(e: any) {
        if (props.onChange != null) {
            props.onChange("" + e.value)
            e.preventDefault()
        }
    }

    return <>
        <div className={"property-element"}>
            <label
                className={(props.labelAdditionalClassName == null ? "" : (" " + props.labelAdditionalClassName))}>
                {props.label}
            </label>
            <Dropdown
                className={"item" + (props.inputAdditionalClassName == null ? "" : (" " + props.inputAdditionalClassName))}
                value={props.val}
                onChange={handleOnChange}
                options={props.options}
            />
        </div>
    </>
}

export default PredefinedTextSetProperty